import isEmpty from 'lodash/isEmpty';
import { fireStore } from '../firebase';

export const getDocs = async ({ filter }) => {
  let docRef = fireStore.collection('roles');
  
  if (filter) {
    if (filter.email) {
      docRef = docRef.where('email', '==', filter.email).limit(1);
    }

    if (filter.line_manager) {
      docRef = docRef.where('line_manager', '==', filter.line_manager);
    }
  
    if (!isEmpty(filter.role)) {
      if (Array.isArray(filter.role)) {
        docRef = docRef.where('role', 'in', filter.role);
      } else {
        docRef = docRef.where('role', '==', filter.role);
      }
    }
  }

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('roles').add(data);
}

export const updateDoc = async ({data}) => {
  const { id, ...payload } = data;
  return await fireStore.collection('roles').doc(id).update(payload);
}

export const deleteDoc = async ({ id }) => {
  return await fireStore.collection('roles').doc(id).delete();
}
